var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rhg-instructions-map__error"},[_c('i',{staticClass:"rhg-font-icon--no-results"}),_c('p',{staticClass:"rhg-instructions-map__message"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }